import HttpClient from "../httpClient";
import { DefaultResponse } from "../../models/types/common";
import { StaticDataItem, StatisticMinMaxDataItem, StatisticThresholdExceedanceDataItem, StatisticNumberOfTimesExceededDataItem } from "../../models/types/statistic";

const getQuery = (params: Record<string, any>) => {
    const queryParts: string[] = [];

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {
                queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
            });
        } else if (value !== undefined && value !== null) {
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });

    return queryParts.length ? `?${queryParts.join('&')}` : '';
}

class StatisticService {
    private service = HttpClient;

    /**
     * Lấy dữ liệu thống kê quan trắc
     * @param requestData
     * @returns
     */
    async getStaticData(requestData: any): Promise<DefaultResponse<{ totalCount: number; data: StaticDataItem[] }>> {
        const queryString = getQuery(requestData);
        const response = await this.service.get<DefaultResponse<{ totalCount: number; data: StaticDataItem[] }>>("/admin/Dashboard/GetStaticData" + queryString);
        return response;
    }

    async exportStatisticData(requestData: any): Promise<Blob> {
        const queryString = getQuery(requestData);
        const response = await this.service.getBinary<Blob>("/admin/Dashboard/ExportStatisticData" + queryString);
        return response;
    }

    /**
     * Lấy dữ liệu thống kê giá trị tối đa tối thiểu
     * @param requestData
     * @returns
     */
    async getMinMaxParameterData(requestData: any): Promise<DefaultResponse<StatisticMinMaxDataItem[]>> {
        const queryString = getQuery(requestData);
        const response = await this.service.get<DefaultResponse<StatisticMinMaxDataItem[]>>("/admin/Dashboard/GetMinMaxParameterData" + queryString);
        return response;
    }

    async exportMinMaxParameterData(requestData: any): Promise<Blob> {
        const queryString = getQuery(requestData);
        const response = await this.service.getBinary<Blob>("/admin/Dashboard/ExportMinMaxParameterData" + queryString);
        return response;
    }

    /**
     * Lấy dữ liệu thống kê vượt ngưỡng
     * @param requestData
     * @returns
     */
    async getThresholdExceedanceData(requestData: any): Promise<DefaultResponse<{data: StatisticThresholdExceedanceDataItem[], max: number}>> {
        const queryString = getQuery(requestData);
        const response = await this.service.get<DefaultResponse<{data: StatisticThresholdExceedanceDataItem[], max: number}>>("/admin/Dashboard/GetThresholdExceedanceData" + queryString);
        return response;
    }

    async exportThresholdExceedanceData(requestData: any): Promise<Blob> {
        const queryString = getQuery(requestData);
        const response = await this.service.getBinary<Blob>("/admin/Dashboard/ExportThresholdExceedanceData" + queryString);
        return response;
    }

    /**
     * Lấy dữ liệu thống kê số lần vượt ngưỡng
     * @param requestData
     * @returns
     */
    async getNumberOfTimesExceeded(requestData: any): Promise<DefaultResponse<StatisticNumberOfTimesExceededDataItem[]>> {
        const queryString = getQuery(requestData);
        const response = await this.service.get<DefaultResponse<StatisticNumberOfTimesExceededDataItem[]>>("/admin/Dashboard/GetNumberOfTimesExceededData" + queryString);
        return response;
    }

    async exportNumberOfTimesExceeded(requestData: any): Promise<Blob> {
        const queryString = getQuery(requestData);
        const response = await this.service.getBinary<Blob>("/admin/Dashboard/ExportNumberOfTimesExceededData" + queryString);
        return response;
    }
}

const statisticSvc = new StatisticService();
export default statisticSvc;
